import type { MarketingPageId } from "./routes";

const LABELS: Record<MarketingPageId, [key: string, fallback: string]> = {
  home: ["marketing.nav.home", "Accueil"],
  ownerAccount: ["marketing.nav.ownerAccount", "Propriétaire"],
  managerAccount: ["marketing.nav.managerAccount", "Gestionnaire"],
  management: ["marketing.nav.management", "Gestion locative"],
  network: ["marketing.nav.network", "Réseau de partenaires"],
  sharing: ["marketing.nav.sharing", "Partage & cascade"],
  requests: ["marketing.nav.requests", "Demandes & réservations"],
  messaging: ["marketing.nav.messaging", "Messagerie partenaires"],
  ownerPortal: ["marketing.nav.ownerPortal", "Portail"],
  partnerAccount: ["marketing.nav.partnerAccount", "Partenaire"],
  pricing: ["marketing.nav.pricing", "Tarifs"],
  about: ["marketing.nav.about", "À propos"],
  contact: ["marketing.nav.contact", "Contact"],
  help: ["marketing.nav.guide", "Guide"],
  privacy: ["marketing.nav.privacy", "Confidentialité"],
  terms: ["marketing.nav.terms", "Conditions"],
};

export function navLabel(
  id: MarketingPageId,
  t: (key: string, fallback: string) => string,
): string {
  const [key, fallback] = LABELS[id];
  return t(key, fallback);
}
